import { TypeSuggestion } from "../type";
import {
  FETCH_COMMUNITY_FOLLOW_MAIN_ERROR,
  FETCH_COMMUNITY_FOLLOW_MAIN_REQUEST,
  FETCH_COMMUNITY_FOLLOW_MAIN_SUCCESS,
  FETCH_COMMUNITY_TREND_MAIN_ERROR,
  FETCH_COMMUNITY_TREND_MAIN_REQUEST,
  FETCH_COMMUNITY_TREND_MAIN_SUCCESS,
  FETCH_COMMUNITY_VIDEO_MAIN_ERROR,
  FETCH_COMMUNITY_VIDEO_MAIN_REQUEST,
  FETCH_COMMUNITY_VIDEO_MAIN_SUCCESS,
  FETCH_COUPANG_RECO_ERROR,
  FETCH_COUPANG_RECO_REQUEST,
  FETCH_COUPANG_RECO_SUCCESS,
  FETCH_FAVORITES_MAIN_ERROR,
  FETCH_FAVORITES_MAIN_REQUEST,
  FETCH_FAVORITES_MAIN_SUCCESS,
  FETCH_HISTORY_MAIN_ERROR,
  FETCH_HISTORY_MAIN_REQUEST,
  FETCH_HISTORY_MAIN_SUCCESS,
  FETCH_MY_INGREDIENTS_ERROR,
  FETCH_MY_INGREDIENTS_REQUEST,
  FETCH_MY_INGREDIENTS_SUCCESS,
  FETCH_RANDOM_RECIPE_ERROR,
  FETCH_RANDOM_RECIPE_REQUEST,
  FETCH_RANDOM_RECIPE_SUCCESS,
  FETCH_SUGGESTION_BY_TYPE_ERROR,
  FETCH_SUGGESTION_BY_TYPE_REQUEST,
  FETCH_SUGGESTION_BY_TYPE_SUCCESS,
  FETCH_USER_SUGGESTION_MAIN_ERROR,
  FETCH_USER_SUGGESTION_MAIN_REQUEST,
  FETCH_USER_SUGGESTION_MAIN_SUCCESS,
  FETCH_WEATHER_MAIN_ERROR,
  FETCH_WEATHER_MAIN_REQUEST,
  FETCH_WEATHER_MAIN_SUCCESS,
  IFetchCommunityFollowMainErrorAction,
  IFetchCommunityFollowMainRequest,
  IFetchCommunityFollowMainRequestAction,
  IFetchCommunityFollowMainSuccessAction,
  IFetchCommunityMainResponse,
  IFetchCommunityTrendMainErrorAction,
  IFetchCommunityTrendMainRequest,
  IFetchCommunityTrendMainRequestAction,
  IFetchCommunityTrendMainSuccessAction,
  IFetchCommunityVideoMainErrorAction,
  IFetchCommunityVideoMainRequest,
  IFetchCommunityVideoMainRequestAction,
  IFetchCommunityVideoMainSuccessAction,
  IFetchFavoritesMainErrorAction,
  IFetchFavoritesMainRequest,
  IFetchFavoritesMainRequestAction,
  IFetchFavoritesMainResponse,
  IFetchFavoritesMainSuccessAction,
  IFetchHistoryMainErrorAction,
  IFetchHistoryMainRequest,
  IFetchHistoryMainRequestAction,
  IFetchHistoryMainSuccessAction,
  IFetchMyIngredientsErrorAction,
  IFetchMyIngredientsRequest,
  IFetchMyIngredientsRequestAction,
  IFetchMyIngredientsResponse,
  IFetchMyIngredientsSuccessAction,
  IFetchRandomRecipeErrorAction,
  IFetchRandomRecipeRequest,
  IFetchRandomRecipeRequestAction,
  IFetchRandomRecipeResponse,
  IFetchRandomRecipeSuccessAction,
  IFetchSuggestionByTypeErrorAction,
  IFetchSuggestionByTypeRequest,
  IFetchSuggestionByTypeRequestAction,
  IFetchSuggestionByTypeResponse,
  IFetchSuggestionByTypeSuccessAction,
  IFetchUserSuggestionMainErrorAction,
  IFetchUserSuggestionMainRequestAction,
  IFetchUserSuggestionMainSuccessAction,
  IFetchWeatherMainErrorAction,
  IFetchWeatherMainRequest,
  IFetchWeatherMainRequestAction,
  IFetchWeatherMainResponse,
  IFetchWeatherMainSuccessAction,
  IReloadUserSuggestionMainRequestAction,
  IRemoveFavoritesMainAction,
  RELOAD_USER_SUGGESTION_MAIN_REQUEST,
  REMOVE_FAVORITES_MAIN,
} from "./types";

export const fetchMyIngredientsRequest = (
  data: IFetchMyIngredientsRequest
): IFetchMyIngredientsRequestAction => ({
  type: FETCH_MY_INGREDIENTS_REQUEST,
  payload: data,
});

export const fetchMyIngredientsSuccess = (
  data: IFetchMyIngredientsResponse
): IFetchMyIngredientsSuccessAction => ({
  type: FETCH_MY_INGREDIENTS_SUCCESS,
  payload: data,
});

export const fetchMyIngredientsError = (
  error: Error
): IFetchMyIngredientsErrorAction => ({
  type: FETCH_MY_INGREDIENTS_ERROR,
  payload: error,
});

//random recipe
export const fetchRandomRecipeRequest = (
  data: IFetchRandomRecipeRequest
): IFetchRandomRecipeRequestAction => ({
  type: FETCH_RANDOM_RECIPE_REQUEST,
  payload: data,
});

export const fetchRandomRecipeSuccess = (
  data: IFetchRandomRecipeResponse
): IFetchRandomRecipeSuccessAction => ({
  type: FETCH_RANDOM_RECIPE_SUCCESS,
  payload: data,
});

export const fetchRandomRecipeError = (
  error: Error
): IFetchRandomRecipeErrorAction => ({
  type: FETCH_RANDOM_RECIPE_ERROR,
  payload: error,
});

//suggestion by type
export const fetchSuggestionByTypeRequest = (
  data: IFetchSuggestionByTypeRequest
): IFetchSuggestionByTypeRequestAction => ({
  type: FETCH_SUGGESTION_BY_TYPE_REQUEST,
  payload: data,
});

export const fetchSuggestionByTypeSuccess = (
  data: IFetchSuggestionByTypeResponse,
  params: TypeSuggestion
): IFetchSuggestionByTypeSuccessAction => ({
  type: FETCH_SUGGESTION_BY_TYPE_SUCCESS,
  payload: data,
  params: params,
});

export const fetchSuggestionByTypeError = (
  error: Error
): IFetchSuggestionByTypeErrorAction => ({
  type: FETCH_SUGGESTION_BY_TYPE_ERROR,
  payload: error,
});


export const fetchFavoritesMainRequest = (
  data: IFetchFavoritesMainRequest
): IFetchFavoritesMainRequestAction => ({
  type: FETCH_FAVORITES_MAIN_REQUEST,
  payload: data,
});

export const RemoveFavoritesMain = (
  data: any
): IRemoveFavoritesMainAction => ({
  type: REMOVE_FAVORITES_MAIN,
  payload: data,
});

export const fetchFavoritesMainSuccess = (
  data: IFetchFavoritesMainResponse
): IFetchFavoritesMainSuccessAction => ({
  type: FETCH_FAVORITES_MAIN_SUCCESS,
  payload: data,
});

export const fetchFavoritesMainError = (
  error: Error
): IFetchFavoritesMainErrorAction => ({
  type: FETCH_FAVORITES_MAIN_ERROR,
  payload: error,
});

export const fetchWeatherMainRequest = (
  data: IFetchWeatherMainRequest
): IFetchWeatherMainRequestAction => ({
  type: FETCH_WEATHER_MAIN_REQUEST,
  payload: data,
});


export const fetchWeatherMainSuccess = (
  data: IFetchWeatherMainResponse
): IFetchWeatherMainSuccessAction => ({
  type: FETCH_WEATHER_MAIN_SUCCESS,
  payload: data,
});

export const fetchWeatherMainError = (
  error: Error
): IFetchWeatherMainErrorAction => ({
  type: FETCH_WEATHER_MAIN_ERROR,
  payload: error,
});


export const fetchHistoryMainRequest = (
  data: IFetchHistoryMainRequest
): IFetchHistoryMainRequestAction => ({
  type: FETCH_HISTORY_MAIN_REQUEST,
  payload: data,
});

export const fetchHistoryMainSuccess = (
  data: IFetchWeatherMainResponse
): IFetchHistoryMainSuccessAction => ({
  type: FETCH_HISTORY_MAIN_SUCCESS,
  payload: data,
});

export const fetchHistoryMainError = (
  error: Error
): IFetchHistoryMainErrorAction => ({
  type: FETCH_HISTORY_MAIN_ERROR,
  payload: error,
});


export const fetchCoupangRecoRequest = (
  data: any
): any => ({
  type: FETCH_COUPANG_RECO_REQUEST,
  payload: data,
});

export const fetchCoupangRecoSuccess = (
  data: any
): any => ({
  type: FETCH_COUPANG_RECO_SUCCESS,
  payload: data,
});

export const fetchCoupangRecoError = (
  error: Error
): any => ({
  type: FETCH_COUPANG_RECO_ERROR,
  payload: error,
});

export const fetchCommunityTrendMainRequest = (
  data: IFetchCommunityTrendMainRequest
): IFetchCommunityTrendMainRequestAction => ({
  type: FETCH_COMMUNITY_TREND_MAIN_REQUEST,
  payload: data,
});

export const fetchCommunityTrendMainSuccess = (
  data: IFetchCommunityMainResponse
): IFetchCommunityTrendMainSuccessAction => ({
  type: FETCH_COMMUNITY_TREND_MAIN_SUCCESS,
  payload: data,
});

export const fetchCommunityTrendMainError = (
  error: Error
): IFetchCommunityTrendMainErrorAction => ({
  type: FETCH_COMMUNITY_TREND_MAIN_ERROR,
  payload: error,
});


export const fetchCommunityFollowMainRequest = (
  data: IFetchCommunityFollowMainRequest
): IFetchCommunityFollowMainRequestAction => ({
  type: FETCH_COMMUNITY_FOLLOW_MAIN_REQUEST,
  payload: data,
});

export const fetchCommunityFollowMainSuccess = (
  data: IFetchCommunityMainResponse
): IFetchCommunityFollowMainSuccessAction => ({
  type: FETCH_COMMUNITY_FOLLOW_MAIN_SUCCESS,
  payload: data,
});

export const fetchCommunityFollowMainError = (
  error: Error
): IFetchCommunityFollowMainErrorAction => ({
  type: FETCH_COMMUNITY_FOLLOW_MAIN_ERROR
  ,
  payload: error,
});


export const fetchCommunityVideoMainRequest = (
  data: IFetchCommunityVideoMainRequest
): IFetchCommunityVideoMainRequestAction => ({
  type: FETCH_COMMUNITY_VIDEO_MAIN_REQUEST,
  payload: data,
});

export const fetchCommunityVideoMainSuccess = (
  data: IFetchCommunityMainResponse
): IFetchCommunityVideoMainSuccessAction => ({
  type: FETCH_COMMUNITY_VIDEO_MAIN_SUCCESS,
  payload: data,
});

export const fetchCommunityVideoMainError = (
  error: Error
): IFetchCommunityVideoMainErrorAction => ({
  type: FETCH_COMMUNITY_VIDEO_MAIN_ERROR,
  payload: error,
});

export const fetchUserSuggestionRequest = (
  data: IFetchWeatherMainRequest
): IFetchUserSuggestionMainRequestAction => ({
  type: FETCH_USER_SUGGESTION_MAIN_REQUEST,
  payload: data,
});


export const fetchUserSuggestionSuccess = (
  data: any
): IFetchUserSuggestionMainSuccessAction => ({
  type: FETCH_USER_SUGGESTION_MAIN_SUCCESS,
  payload: data,
});

export const fetchUserSuggestionError = (
  error: Error
): IFetchUserSuggestionMainErrorAction => ({
  type: FETCH_USER_SUGGESTION_MAIN_ERROR,
  payload: error,
});

export const reloadUserSuggestionRequest = (
  data: IFetchWeatherMainRequest
): IReloadUserSuggestionMainRequestAction => ({
  type: RELOAD_USER_SUGGESTION_MAIN_REQUEST,
  payload: data,
});

